// Phase 129 Plan 04 Task 1 — Input primitive (DESIGN.md dark theme).
//
// Unlike frontend/ which uses @base-ui/react for headless behaviour, web/'s
// Input is a plain HTML <input> styled per DESIGN.md dark surface:
//   - bg #0F1112 (deeper than card surface for input contrast)
//   - border white/15
//   - focus ring Meta Blue #0064E0
import * as React from 'react';

import { cn } from '../../lib/utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export function Input({ className, type, ...props }: InputProps) {
  return (
    <input
      data-slot="input"
      type={type ?? 'text'}
      className={cn(
        'w-full min-w-0 rounded-[12px] border border-white/15 bg-[#0F1112] px-4 py-2.5 text-sm text-white placeholder:text-white/40 outline-none transition-colors focus-visible:border-[#0064E0] focus-visible:ring-2 focus-visible:ring-[#0064E0]/40 disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
}
